export default ({ IDL }) => {
  const Property = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
  const Time = IDL.Int;
  const TokenDesc_2 = IDL.Record({
    'id' : IDL.Nat,
    'url' : IDL.Text,
    'owner' : IDL.Principal,
    'desc' : IDL.Text,
    'name' : IDL.Text,
    'properties' : IDL.Vec(Property),
    'date_of_birth' : Time,
    'storage_canister' : IDL.Text,
  });
  const TokenDesc = TokenDesc_2;
  const Listing_2 = IDL.Record({
    'tokenId' : IDL.Nat,
    'owner' : IDL.Principal,
    'timestamp' : Time,
    'price' : IDL.Nat64,
  });
  const Listing = Listing_2;
  const Operation_2 = IDL.Variant({
    'init' : IDL.Null,
    'list' : IDL.Null,
    'mint' : IDL.Null,
    'delist' : IDL.Null,
    'transfer' : IDL.Null,
    'purchase' : IDL.Null,
  });
  const Operation = Operation_2;
  const StorageActor = IDL.Service({
    'addRecord' : IDL.Func(
        [
          IDL.Principal,
          Operation,
          IDL.Opt(IDL.Principal),
          IDL.Opt(IDL.Principal),
          IDL.Nat,
          IDL.Opt(IDL.Nat64),
          Time,
        ],
        [IDL.Nat],
        [],
      ),
  });
  const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
  const HttpRequest_2 = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  const HttpRequest = HttpRequest_2;
  const StreamingCallbackToken = IDL.Record({
    'key' : IDL.Text,
    'sha256' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'index' : IDL.Nat,
    'content_encoding' : IDL.Text,
  });
  const StreamingCallbackResponse = IDL.Record({
    'token' : IDL.Opt(StreamingCallbackToken),
    'body' : IDL.Vec(IDL.Nat8),
  });
  const StreamingStrategy = IDL.Variant({
    'Callback' : IDL.Record({
      'token' : StreamingCallbackToken,
      'callback' : IDL.Func(
          [StreamingCallbackToken],
          [StreamingCallbackResponse],
          ['query'],
        ),
    }),
  });
  const HttpResponse_2 = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
    'streaming_strategy' : IDL.Opt(StreamingStrategy),
    'status_code' : IDL.Nat16,
  });
  const HttpResponse = HttpResponse_2;
  const MintRequest_2 = IDL.Record({
    'url' : IDL.Text,
    'dataurl' : IDL.Text,
    'accountid' : IDL.Text,
    'contentType' : IDL.Text,
    'data' : IDL.Vec(IDL.Nat8),
    'desc' : IDL.Text,
    'name' : IDL.Text,
    'properties' : IDL.Vec(Property),
    'storage_canister' : IDL.Text,
  });
  const MintRequest = MintRequest_2;
  const ICPBunny = IDL.Service({
    'acceptCycles' : IDL.Func([], [], []),
    'addImageCanister' : IDL.Func([IDL.Text, IDL.Nat], [IDL.Bool], []),
    'add_genesis_record' : IDL.Func([], [IDL.Nat], []),
    'availableCycles' : IDL.Func([], [IDL.Nat], ['query']),
    'claim' : IDL.Func([], [IDL.Nat], []),
    'data_of' : IDL.Func([IDL.Nat], [TokenDesc], ['query']),
    'delist' : IDL.Func([IDL.Nat], [IDL.Bool], []),
    'dequeue' : IDL.Func([IDL.Text], [IDL.Opt(IDL.Nat)], []),
    'disableClaim' : IDL.Func([], [IDL.Bool], []),
    'disableMint' : IDL.Func([], [IDL.Bool], []),
    'enableClaim' : IDL.Func([], [IDL.Bool], []),
    'enableMint' : IDL.Func([], [IDL.Bool], []),
    'enqueue' : IDL.Func([IDL.Text], [], []),
    'getAccountID' : IDL.Func([IDL.Nat8, IDL.Nat8], [IDL.Text], ['query']),
    'getAll' : IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat))], ['query']),
    'getCurrentToken' : IDL.Func([], [IDL.Nat], ['query']),
    'getImageCanister' : IDL.Func([IDL.Nat], [IDL.Text], ['query']),
    'getPrice' : IDL.Func([], [IDL.Nat64], ['query']),
    'get_cycles' : IDL.Func([], [IDL.Nat], ['query']),
    'get_listed' : IDL.Func([IDL.Nat], [IDL.Vec(Listing)], ['query']),
    'get_storage_canister' : IDL.Func([], [IDL.Opt(StorageActor)], ['query']),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'individual_holders' : IDL.Func([], [IDL.Nat], ['query']),
    'list' : IDL.Func([IDL.Nat, IDL.Nat64], [IDL.Bool], []),
    'lookup' : IDL.Func([IDL.Text], [IDL.Opt(IDL.Nat)], ['query']),
    'mint' : IDL.Func([MintRequest], [IDL.Nat], []),
    'my_tokens' : IDL.Func([], [IDL.Vec(IDL.Nat)], []),
    'name' : IDL.Func([], [IDL.Text], ['query']),
    'nextAccount' : IDL.Func([], [IDL.Nat], []),
    'owner' : IDL.Func([], [IDL.Principal], ['query']),
    'owner_of' : IDL.Func([IDL.Nat], [IDL.Principal], ['query']),
    'remainingMint' : IDL.Func([], [IDL.Nat], ['query']),
    'remainingTokens' : IDL.Func([], [IDL.Nat], ['query']),
    'setPrice' : IDL.Func([IDL.Nat64], [IDL.Bool], []),
    'set_ledger_canister_id' : IDL.Func(
        [IDL.Opt(IDL.Principal)],
        [IDL.Bool],
        [],
      ),
    'set_owner' : IDL.Func([IDL.Principal], [IDL.Bool], []),
    'set_storage_canister_id' : IDL.Func(
        [IDL.Opt(IDL.Principal)],
        [IDL.Bool],
        [],
      ),
    'size' : IDL.Func([], [IDL.Nat], ['query']),
    'symbol' : IDL.Func([], [IDL.Text], ['query']),
    'tokenAccounts' : IDL.Func([IDL.Text], [IDL.Text], []),
    'total_supply' : IDL.Func([], [IDL.Nat], ['query']),
    'transfer_to' : IDL.Func([IDL.Principal, IDL.Nat], [IDL.Bool], []),
    'user_tokens' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Nat)], ['query']),
    'wallet_receive' : IDL.Func(
        [],
        [IDL.Record({ 'accepted' : IDL.Nat64 })],
        [],
      ),
  });
  return ICPBunny;
};
export const init = ({ IDL }) => {
  return [IDL.Text, IDL.Text, IDL.Nat, IDL.Principal];
};